export function isString(value: unknown): value is string {
    return typeof value === 'string';
}

export function isNumber(value: unknown): value is number {
    return typeof value === 'number';
}

export function isFunction(value: unknown): value is string {
    return typeof value === 'function';
}

export function isBoolean(value: unknown): value is boolean {
    return typeof value === 'boolean';
}

export function isUndefined(value: unknown): value is undefined {
    return typeof value === 'undefined';
}

export function isDate(value: unknown): value is Date {
    return value instanceof Date;
}

export function isObject(value: unknown): value is Object {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isArray<TData = unknown>(value: unknown): value is TData[] {
    return Array.isArray(value);
}
